/* Site-Specific JavaScript – header + footer (jQuery) */

(function (jq) {
  'use strict';

  var CLASS_NAV = 'nav-menu';
  var CLASS_ITEM_TRIGGER = 'nav-item-trigger';
  var CLASS_DROPDOWN = 'dropdown';
  var CLASS_OVERLAY = 'overlay';
  var CLASS_LOGO_LINK = 'logo-link';
  var CLASS_MOBILE_TRIGGER = 'hamburger';

  var currentOpen = null;
  var mobileMenuOpen = false;
  var $overlay;
  var $nav = jq('#nav');

  var isDesktop = window.matchMedia('(min-width: 1024px)');
  var ARIA_OPEN_MENU = 'Open menu';
  var ARIA_CLOSE_MENU = 'Close menu';

  function setOverlayDisplay(showOverlay) {
    if (showOverlay) {
      $overlay.addClass('show');
    } else {
      $overlay.removeClass('show');
    }
  }

  function closeAllDropdowns() {
    if (!currentOpen) return;
    $nav.find('.' + CLASS_ITEM_TRIGGER).attr('aria-expanded', 'false');
    currentOpen = null;
    setOverlayDisplay(false);
    $nav.find('.' + CLASS_NAV).removeClass('active');
  }

  function closeMobileMenu($hamburgerBtn) {
    var $trigger = $hamburgerBtn && $hamburgerBtn.length
      ? $hamburgerBtn
      : $nav.find('.' + CLASS_MOBILE_TRIGGER);
    var $menu = $nav.find('.nav-navigation .' + CLASS_NAV);

    mobileMenuOpen = false;
    $trigger.attr({ 'aria-expanded': 'false', 'aria-label': ARIA_OPEN_MENU });
    $nav.attr('aria-expanded', 'false');
    jq('body').removeClass('mobile-nav-open');
    $menu.removeClass('active');
  }

  function openMobileMenu($hamburgerBtn) {
    var $trigger = $hamburgerBtn && $hamburgerBtn.length
      ? $hamburgerBtn
      : $nav.find('.' + CLASS_MOBILE_TRIGGER);

    closeAllDropdowns();

    mobileMenuOpen = true;
    $trigger.attr({ 'aria-expanded': 'true', 'aria-label': ARIA_CLOSE_MENU });
    $nav.attr('aria-expanded', 'true');
    jq('body').addClass('mobile-nav-open');
  }

  function handleMobileNavClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = jq(e.currentTarget);
    if (mobileMenuOpen) {
      closeMobileMenu($btn);
    } else {
      openMobileMenu($btn);
    }
  }

  function toggleDropdown(button) {
    var $btn = jq(button);
    var $dropdown = $btn.next('.' + CLASS_DROPDOWN);
    var isOpen = $btn.attr('aria-expanded') === 'true';
    var $menu = $nav.find('.nav-navigation .' + CLASS_NAV);

    if (currentOpen && currentOpen.length && !currentOpen.is($dropdown)) {
      closeAllDropdowns();
    }

    if (isOpen) {
      $btn.attr('aria-expanded', 'false');
      $menu.removeClass('active');
      currentOpen = null;
    } else {
      $btn.attr('aria-expanded', 'true');
      $menu.addClass('active');
      currentOpen = $dropdown;
    }

    setOverlayDisplay(!!currentOpen && currentOpen.length);
  }

  function handleNavTriggerClick(e) {
    e.preventDefault();
    e.stopPropagation();
    toggleDropdown(e.currentTarget);
  }

  function handleOverlayClick() {
    closeAllDropdowns();
    closeMobileMenu();
  }

  function handleNavTriggerKeydown(e, triggerBtn) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleDropdown(triggerBtn);
    }
  }

  function closeSearch() {
    $nav.find('.nav-search .search-trigger[aria-expanded="true"]').attr('aria-expanded', 'false');
  }

  function handleBlockKeydown(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
      closeMobileMenu();
      closeSearch();
    } else if (e.key === 'Tab' && (currentOpen && currentOpen.length || mobileMenuOpen)) {
      setTimeout(function () {
        var active = document.activeElement;
        var $active = jq(active);
        var isOtherNavControl = $active.hasClass(CLASS_ITEM_TRIGGER) ||
          $active.hasClass('nav-item-link') ||
          $active.hasClass(CLASS_LOGO_LINK) ||
          $active.hasClass(CLASS_MOBILE_TRIGGER);
        var isInsideNav = jq(active).closest('#nav').length;
        if (isOtherNavControl || !isInsideNav) {
          closeAllDropdowns();
          if (!isInsideNav) {
            closeMobileMenu();
          }
        }
      }, 10);
    }
  }

  function handlePageResize() {
    if (isDesktop.matches) {
      closeMobileMenu();
    }
    closeAllDropdowns();
  }

  function handleSearchDisplayClick(e) {
    var $trigger = jq(e.currentTarget);
    var $block = $trigger.closest('.nav-search');
    var $input = $block.find('input');
    $trigger.attr('aria-expanded', 'true');
    setTimeout(function () {
      if ($input.length) $input[0].focus();
    }, 400);
  }

  function handleSearchFocusOut(e) {
    var $block = jq(e.currentTarget);
    var $trigger = $block.find('.search-trigger');
    setTimeout(function () {
      if (!$block[0].contains(document.activeElement)) {
        $trigger.attr('aria-expanded', 'false');
      }
    }, 500);
  }

  function handleSkipToMainClick(e) {
    e.preventDefault();
    var mainEl = document.getElementById('main') || document.getElementById('mainContent') || document.querySelector('main');
    if (mainEl) {
      if (!mainEl.hasAttribute('tabindex')) mainEl.setAttribute('tabindex', '-1');
      mainEl.focus();
    }
    if (e.target && e.target.blur) e.target.blur();
  }

  function getCookie(name) {
    if (!document.cookie) return null;
    var escaped = name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function updateHeaderAuthState() {
    if (!$nav.length) return;
    var $loggedOut = $nav.find('.nav-logged-out');
    var $loggedIn = $nav.find('.nav-logged-in');
    var username = getCookie('fdxf-contactname');

    if (username) {
      $loggedOut.addClass('hidden');
      $loggedIn.removeClass('hidden');
      $nav.find('.nav-logged-in .nav-item-label').text(username.trim());
    } else {
      $loggedIn.addClass('hidden');
      $loggedOut.removeClass('hidden');
    }
    closeAllDropdowns();
    closeMobileMenu();
  }

  function debounce(fn, ms) {
    var timeout;
    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  function initHeaderDropdowns() {
    if (!$nav.length) return;

    $overlay = $nav.find('.' + CLASS_OVERLAY);
    if (!$overlay.length) {
      $overlay = jq('.' + CLASS_OVERLAY);
    }

    $nav.on('click', '.' + CLASS_ITEM_TRIGGER, handleNavTriggerClick);
    $nav.on('click', '.' + CLASS_MOBILE_TRIGGER, handleMobileNavClick);
    $nav.on('click', '.' + CLASS_OVERLAY, handleOverlayClick);
    $nav.on('click', '.search-trigger', handleSearchDisplayClick);
    $nav.on('focusout', '.nav-search', handleSearchFocusOut);
    $nav.on('submit', '.search-form', function (e) {
      e.preventDefault();
      var $form = jq(e.target).closest('form');
      var q = ($form.find('input[name="q"]').val() || '').trim();
      if (!q) return;
      var resultsPath = $form.attr('data-search-results-path');
      if (!resultsPath) {
        var base = getIntegratedMainUrl();
        if (!base) return;
        resultsPath = base.replace(/\/+$/, '') + '/search';
      }
      var searchUrl = resultsPath + '?q=' + encodeURIComponent(q);
      window.location.href = searchUrl;
    });
    $nav.on('click', '.skip-to-main', handleSkipToMainClick);
    jq(document).on('click', 'a[href="#main"], a[href="#mainContent"]', handleSkipToMainClick);
    $nav.on('keydown', '.' + CLASS_ITEM_TRIGGER, function (e) {
      handleNavTriggerKeydown(e, this);
    });
    $nav.on('keydown', handleBlockKeydown);
    jq(window).on('resize', debounce(handlePageResize, 300));

    updateHeaderAuthState();
    if (typeof window !== 'undefined') {
      window.updateHeaderAuthState = updateHeaderAuthState;
    }
  }

  /* --- Footer (static; footer.js only had structure + button normalization) --- */
  function initFooter() {
    var $block = jq('[data-block-name="footer"]');
    if (!$block.length) return;
    $block.find('.button-container a.button').removeClass('button')
      .closest('.button-container').removeClass('button-container');
  }

  /* --- Tracking block (behavior only; DOM assumed present) ---
   * Config: set data-tracking-url on the block, or window.TRACKING_PLACEHOLDERS = { trackingurl, trackinginput, trackingtext }. */
  var TRACKING_DEFAULTS = {
    placeholder: 'Enter tracking number',
    errorText: 'Please enter a tracking number.',
    urlNotConfigured: 'Tracking URL is not configured.'
  };

  function handleTracking(trackingNumber, trackingBaseUrl) {
    if (!trackingBaseUrl) return;
    var baseUrl = (trackingBaseUrl + '').trim().replace(/\/+$/, '');
    window.location.href = baseUrl + trackingNumber;
  }

  function resetTrackingErrors($input, $label, $errorMsg) {
    $label.removeClass('error');
    $errorMsg.css('display', 'none').removeClass('visible');
  }

  function initTracking() {
    var $blocks = jq('.tracking.block, [data-block-name="tracking"]');
    $blocks.each(function () {
      var block = this;
      var $block = jq(block);
      var $content = $block.find('.tracking-content');
      if (!$content.length) return;

      var $label = $content.find('.tracking-label');
      var $input = $content.find('.tracking-input');
      var $errorMsg = $content.find('.tracking-error-msg');
      var $errorText = $content.find('.tracking-error-text');
      var $closeIcon = $content.find('.status-close-icon');
      var $btn = $content.find('.tracking-btn');

      var config = window.TRACKING_PLACEHOLDERS || {};
      var baseUrl = $block.attr('data-tracking-url') || config.trackingurl || '';
      var placeholder = $block.attr('data-tracking-placeholder') || config.trackinginput || TRACKING_DEFAULTS.placeholder;
      var errorText = $block.attr('data-tracking-error') || config.trackingtext || TRACKING_DEFAULTS.errorText;
      var urlNotConfigured = TRACKING_DEFAULTS.urlNotConfigured;

      if (placeholder && $input.length) $input.attr('placeholder', placeholder);

      function showError(msg) {
        $label.addClass('error');
        $errorText.text(msg);
        $errorMsg.css('display', 'flex').addClass('visible');
        $input.focus();
      }

      $closeIcon.on('click', function () {
        $input.val('');
        resetTrackingErrors($input, $label, $errorMsg);
        $input.focus();
      });
      $closeIcon.on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          $closeIcon.trigger('click');
        }
      });

      $btn.on('click', function (e) {
        e.preventDefault();
        var value = $input.val().trim();
        if (!value) {
          showError(errorText);
        } else if (!baseUrl) {
          showError(urlNotConfigured);
        } else {
          resetTrackingErrors($input, $label, $errorMsg);
          handleTracking(value, baseUrl);
        }
      });

      $input.on('input', function () {
        resetTrackingErrors($input, $label, $errorMsg);
      });

      $block.on('resetErrors', function () {
        resetTrackingErrors($input, $label, $errorMsg);
      });
    });
  }

  /* --- Icon-links block (cleanUpExternal only; DOM assumed present) --- */
  function cleanUpExternalLink(linkEl) {
    var el = linkEl && linkEl.jquery ? linkEl[0] : linkEl;
    if (!el) return;
    el.classList.remove('external-link');
    var extIcon = el.querySelector('.navigational_external_link_small');
    if (extIcon) extIcon.remove();
  }

  function initIconLinks() {
    var $blocks = jq('.icon-links.block, [data-block-name="icon-links"]');
    $blocks.each(function () {
      var $block = jq(this);
      $block.find('a.icon-link-item').each(function () {
        var link = this;
        if (link.classList.contains('external-link') || link.querySelector('.navigational_external_link_small')) {
          if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(function () { cleanUpExternalLink(link); });
          } else {
            cleanUpExternalLink(link);
          }
        }
      });
    });
  }

  /* --- Back to top button (element in footer; only behavior attached) --- */
  function initBackToTop() {
    var theButton = document.getElementById('btn-back-to-top');
    if (!theButton) return;

    var buttonThreshold = window.innerHeight;
    var scrollPending = false;

    function updateVisibility() {
      var shouldShow = window.scrollY > buttonThreshold;
      if (shouldShow && theButton.classList.contains('hide')) {
        theButton.classList.remove('hide');
        theButton.setAttribute('tabindex', '0');
      }
      if (!shouldShow && !theButton.classList.contains('hide')) {
        theButton.classList.add('hide');
        theButton.setAttribute('tabindex', '-1');
      }
    }

    updateVisibility();

    window.addEventListener('scroll', function () {
      if (scrollPending) return;
      scrollPending = true;
      requestAnimationFrame(function () {
        updateVisibility();
        scrollPending = false;
      });
    }, { passive: true });

    function goToTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      theButton.classList.add('hide');
      theButton.setAttribute('tabindex', '-1');
      var main = document.querySelector('main');
      if (main) {
        main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
      }
    }

    theButton.addEventListener('click', goToTop);
    theButton.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goToTop();
      }
    });
  }

  /* --- Language selectors (locale from companyVars.website_base_url) --- */
  var LANG_PLACEHOLDERS = {
    countryselecttitle: 'Country',
    languageselecttitle: 'Language',
    languageselectloadingerrortext: 'Unable to load language options.'
  };

  function getLocaleFromWebsiteBaseUrl() {
    try {
      var el = document.getElementById('companyVars');
      if (!el || !el.textContent) return '';
      var vars = JSON.parse(el.textContent);
      var baseUrl = vars && vars.integrated_main_url;
      if (typeof baseUrl !== 'string' || !baseUrl) return '';
      var pathname = new URL(baseUrl).pathname;
      var segments = pathname.split('/').filter(Boolean);
      for (var i = 0; i < segments.length; i++) {
        if (/^[a-z]{2}-[a-z]{2}$/i.test(segments[i])) return segments[i].toLowerCase();
      }
    } catch (e) {}
    return '';
  }

  /**
   * Returns companyVars.integrated_main_url (main site base URL) or empty string.
   */
  function getIntegratedMainUrl() {
    try {
      var el = document.getElementById('companyVars');
      if (!el || !el.textContent) return '';
      var vars = JSON.parse(el.textContent);
      var url = vars && vars.integrated_main_url;
      return typeof url === 'string' ? url : '';
    } catch (e) { return ''; }
  }

  /**
   * Build the main site URL for a given locale (e.g. "en-us") using companyVars.integrated_main_url.
   * Replaces the locale segment in the base path, or appends it. Used for language-selector redirects.
   */
  function getWebsiteBaseUrlForLocale(newLocale) {
    try {
      var el = document.getElementById('companyVars');
      if (!el || !el.textContent) return window.location.origin + '/' + newLocale;
      var vars = JSON.parse(el.textContent);
      var baseUrl = vars && vars.integrated_main_url;
      if (typeof baseUrl !== 'string' || !baseUrl) return window.location.origin + '/' + newLocale;
      var url = new URL(baseUrl);
      var segments = url.pathname.split('/').filter(Boolean);
      if (segments.length && /^[a-z]{2}-[a-z]{2}$/i.test(segments[0])) {
        segments[0] = newLocale;
      } else {
        segments.unshift(newLocale);
      }
      return url.origin + '/' + segments.join('/');
    } catch (e) {
      return window.location.origin + '/' + newLocale;
    }
  }

  function initLanguageSelectors() {
    var block = document.querySelector('.language-selectors.block, [data-block-name="language-selectors"]');
    if (!block) return;

    var ph = window.LANGUAGE_SELECTOR_PLACEHOLDERS || LANG_PLACEHOLDERS;

    fetch('https://wwwdeveds.tst.fedexfreight.com/spreadsheet/language-selectors.json', { cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('Status: ' + res.status)); })
      .then(function (json) {
        var items = (json && json.data) ? json.data : [];
        var locale = getLocaleFromWebsiteBaseUrl();
        var currentLang = '';
        var currentCountry = '';
        if (locale) {
          var parts = locale.split('-');
          currentLang = parts[0] || '';
          currentCountry = parts[1] || '';
        }
        if (!currentCountry || !items.some(function (item) { return item['country.code'] === currentCountry; })) {
          currentCountry = 'us';
          currentLang = 'en';
        }

        block.innerHTML =
          '<div class="language-selector-wrap">' +
            '<div class="globe-contain"></div>' +
            '<div class="dropdowns-contain">' +
              '<div class="dropdown-wrap country-dropdown-wrap">' +
                '<button id="footer-country-trigger" class="dropdown-trigger country-trigger" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="footer-country-list" type="button" name="Country" aria-label="Country, selecting an option opens in a new window">' +
                  '<span aria-hidden="true">' + (ph.countryselecttitle || 'Country') + '</span>' +
                '</button>' +
                '<ul id="footer-country-list" class="dropdown-list country-list" role="listbox" tabindex="-1" aria-labelledby="footer-country-trigger"></ul>' +
              '</div>' +
              '<div class="dropdown-wrap language-dropdown-wrap">' +
                '<button id="footer-language-trigger" class="dropdown-trigger language-trigger" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="footer-language-list" type="button" name="Language" aria-label="Language, selecting an option opens in a new window">' +
                  '<span aria-hidden="true">' + (ph.languageselecttitle || 'Language') + '</span>' +
                '</button>' +
                '<ul id="footer-language-list" class="dropdown-list language-list" role="listbox" tabindex="-1" aria-labelledby="footer-language-trigger"></ul>' +
              '</div>' +
            '</div>' +
          '</div>';

        var globe = block.querySelector('.globe-contain');
        var countryTrigger = block.querySelector('.country-trigger');
        var langTrigger = block.querySelector('.language-trigger');
        var countryList = block.querySelector('.country-list');
        var langList = block.querySelector('.language-list');

        if (globe) globe.innerHTML = '<svg role="img" aria-label="Select country and language"><use href="#locations_globe_small"></use></svg>';

        function closeDropdowns() {
          [countryList, langList].forEach(function (ul) { ul.style.display = 'none'; });
          [countryTrigger, langTrigger].forEach(function (btn) {
            btn.setAttribute('aria-expanded', 'false');
            btn.removeAttribute('aria-activedescendant');
          });
          [].slice.call(countryList.children).concat([].slice.call(langList.children)).forEach(function (li) { li.tabIndex = -1; });
        }

        function setActiveDescendant(trigger, optionEl) {
          if (optionEl && optionEl.id) {
            trigger.setAttribute('aria-activedescendant', optionEl.id);
          } else {
            trigger.removeAttribute('aria-activedescendant');
          }
        }

        function openDropdown(trigger, list) {
          closeDropdowns();
          list.style.display = 'block';
          trigger.setAttribute('aria-expanded', 'true');
          var dropdownItems = [].slice.call(list.children);
          dropdownItems.forEach(function (li) { li.tabIndex = 0; });
          var toFocus = list.querySelector('.selected') || dropdownItems[0];
          if (toFocus) {
            toFocus.focus();
            setActiveDescendant(trigger, toFocus);
          }
        }

        items.forEach(function (item, idx) {
          var li = document.createElement('li');
          li.id = 'footer-country-option-' + (item['country.code'] || idx);
          li.className = 'dropdown-item';
          li.setAttribute('role', 'option');
          li.setAttribute('tabindex', '-1');
          li.setAttribute('data-value', item['country.code']);
          li.textContent = item['country.label'] || '';
          countryList.appendChild(li);
        });

        function populateLanguages(countryCode, selectedLang) {
          selectedLang = selectedLang || '';
          var country = items.find(function (item) { return item['country.code'] === countryCode; });
          if (!country) return;
          var langs = [
            { code: country['country.language.first.code'], label: country['country.language.first.label'] },
            { code: country['country.language.second.code'], label: country['country.language.second.label'] }
          ].filter(function (lang) { return lang.code && lang.label; });
          langList.innerHTML = '';
          langs.forEach(function (lang, idx) {
            var li = document.createElement('li');
            li.id = 'footer-language-option-' + (lang.code || idx);
            li.className = 'dropdown-item' + (lang.code === selectedLang ? ' selected' : '');
            li.setAttribute('role', 'option');
            li.setAttribute('data-value', lang.code);
            li.textContent = lang.label || '';
            langList.appendChild(li);
          });
        }

        countryTrigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (countryList.style.display === 'block') closeDropdowns();
          else openDropdown(countryTrigger, countryList);
        });
        langTrigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (langList.style.display === 'block') closeDropdowns();
          else openDropdown(langTrigger, langList);
        });
        document.addEventListener('click', closeDropdowns);

        [countryTrigger, langTrigger].forEach(function (trigger, idx) {
          var list = idx === 0 ? countryList : langList;
          trigger.addEventListener('keydown', function (e) {
            if ((e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') && list.children.length) {
              e.preventDefault();
              openDropdown(trigger, list);
            }
          });
        });

        [countryList, langList].forEach(function (list, idx) {
          var trigger = idx === 0 ? countryTrigger : langTrigger;
          list.addEventListener('keydown', function (e) {
            var dropdownItems = [].slice.call(list.children);
            var current = document.activeElement;
            var currentIdx = dropdownItems.indexOf(current);
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              var next = dropdownItems[(currentIdx + 1) % dropdownItems.length];
              next.focus();
              setActiveDescendant(trigger, next);
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              var prev = dropdownItems[(currentIdx - 1 + dropdownItems.length) % dropdownItems.length];
              prev.focus();
              setActiveDescendant(trigger, prev);
            } else if (e.key === 'Escape') {
              closeDropdowns();
              trigger.focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (current && current.click) current.click();
            }
          });
          list.addEventListener('focus', function (e) {
            if (e.target.getAttribute('role') === 'option' && list.style.display === 'block') {
              setActiveDescendant(trigger, e.target);
            }
          });
        });

        countryList.addEventListener('click', function (e) {
          var li = e.target.closest ? e.target.closest('li') : (e.target.tagName === 'LI' ? e.target : null);
          if (!li) return;
          var country = li.getAttribute('data-value');
          countryTrigger.querySelector('span').textContent = li.textContent;
          [].slice.call(countryList.children).forEach(function (el) { el.classList.remove('selected'); });
          li.classList.add('selected');
          closeDropdowns();
          populateLanguages(country);
          var firstLang = items.find(function (item) { return item['country.code'] === country; });
          firstLang = firstLang && firstLang['country.language.first.code'];
          if (firstLang) {
            var firstLangLi = langList.querySelector('[data-value="' + firstLang + '"]');
            if (firstLangLi) {
              langTrigger.querySelector('span').textContent = firstLangLi.textContent;
              [].slice.call(langList.children).forEach(function (el) { el.classList.remove('selected'); });
              firstLangLi.classList.add('selected');
            }
            window.location.href = getWebsiteBaseUrlForLocale(firstLang + '-' + country);
          }
        });

        langList.addEventListener('click', function (e) {
          var li = e.target.closest ? e.target.closest('li') : (e.target.tagName === 'LI' ? e.target : null);
          if (!li) return;
          var lang = li.getAttribute('data-value');
          [].slice.call(langList.children).forEach(function (el) { el.classList.remove('selected'); });
          li.classList.add('selected');
          langTrigger.querySelector('span').textContent = li.textContent;
          closeDropdowns();
          var countryLi = countryList.querySelector('.selected');
          var country = countryLi ? countryLi.getAttribute('data-value') : '';
          if (!country || !lang) return; 
          var pathSegments = window.location.pathname.split('/').filter(Boolean);
          var currentPage = (locale && pathSegments.length > 1) ? pathSegments.slice(1).join('/') : '';
          var basePath = getWebsiteBaseUrlForLocale(lang + '-' + country);
          var targetUrl = currentPage ? basePath + '/' + currentPage : basePath;
          fetch(targetUrl, { method: 'HEAD' })
            .then(function (res) { window.location.href = res.ok ? targetUrl : basePath; })
            .catch(function () { window.location.href = basePath; });
        });

        if (currentCountry && items.find(function (item) { return item['country.code'] === currentCountry; })) {
          var countryLi = [].slice.call(countryList.children).find(function (li) { return li.getAttribute('data-value') === currentCountry; });
          if (countryLi) {
            countryLi.classList.add('selected');
            countryTrigger.querySelector('span').textContent = countryLi.textContent;
          }
          populateLanguages(currentCountry, currentLang);
          if (currentLang) {
            var langLi = [].slice.call(langList.children).find(function (li) { return li.getAttribute('data-value') === currentLang; });
            if (langLi) {
              langLi.classList.add('selected');
              langTrigger.querySelector('span').textContent = langLi.textContent;
            }
          }
        }
      })
      .catch(function () {
        block.innerHTML = '<p style="color:red;">' + (ph.languageselectloadingerrortext || LANG_PLACEHOLDERS.languageselectloadingerrortext) + '</p>';
      });
  }

  jq(function () {
    if (window.FedExUtils && typeof window.FedExUtils.loadSVGSprite === 'function') {
      window.FedExUtils.loadSVGSprite();
    }
    initHeaderDropdowns();
    initFooter();
    initTracking();
    initIconLinks();
    initBackToTop();
    initLanguageSelectors();
  });

})(jQuery);
